export enum ToastTypeEnum {
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
  QUESTION = 'question',
  PERMISSION = 'permission',
  INTERNAL = 'internal',
}
